export const menuList = [{
		title: "用户管理",
		icon: "user",
		name: "VIPMANAGEMODULE",
		children: [{
			title: "用户管理",
			router: "vipList",
			name: "VIPLIST",
		}, ],
	},
	{
		title: "工厂管理",
		icon: "shop",
		name: "FACTORYMODULE",
		children: [{
			title: "工厂管理",
			router: "factoryManage",
			name: "FACTORYMANAGE",
		}],
	},
	{
		title: "品牌管理",
		icon: "tags",
		name: "BRANDMODULE",
		children: [{
			title: "品牌管理",
			router: "brandpage",
			name: "BRANDMANAGE",
		}],
	},
	{
		title: "法规管理",
		icon: "file-protect",
		name: "LAWSMODULE",
		children: [{
				title: "执行标准",
				router: "executionStandard",
				name: "EXECUTIONSTANDARD",
				children: [],
			},
			{
				title: "法律法规",
				router: "lawsRegulations",
				name: "LAWSREGULATIONS",
				children: [],
			},
			{
				title: "处罚案例",
				router: "triggerCase",
				name: "TRIGGERCASE",
				children: [],
			},
			{
				title: "投诉指南",
				router: "complaintGuide",
				name: "COMPLAINTGUIDE",
				children: [],
			}
		],
	},
	{
		title: "标签设置",
		icon: "tag",
		name: "LABELMODULE",
		children: [{
				title: "标签设置",
				router: "labelSettings",
				name: "LABELSETTINGS",
				children: [],
			},
			{
				title: "其他标签管理",
				router: "fctory_band_spplierManage",
				name: "FCTORY_BAND_SPPLIERMANAGE",
				children: [],
			},
			{
				title: "首页筛选",
				router: "homepage",
				name: "HOMEPAGE",
				children: [],
			}
		],
	},
	{
		title: "互动管理",
		icon: "message",
		name: "INTERMODULE",
		children: [{
				title: "口碑互动",
				router: "wordmouthPage",
				name: "WORDMOUTHPAGE",
				children: [],
			},
			{
				title: "举报管理",
				router: "complaintManage",
				name: "COMPLAINTMANAGE",
				children: [],
			},
			{
				title: "敏感词管理",
				router: "sensitiveWordManage",
				name: "SENSITIVEWORDMANAGE",
				children: [],
			},
			{
				title: "角色管理",
				router: "roleManage",
				name: "ROLEMANAGE",
				children: [],
			}
		],
	},
	{
		title: "广告管理",
		icon: "notification",
		name: "ADMODULE",
		children: [{
			title: "广告管理",
			router: "adManage",
			name: "ADMANAGE",
		}],
	},
	{
		title: "搜索管理",
		icon: "search",
		name: "SEARCHMODULE",
		children: [{
			title: "搜索管理",
			router: "searchManage",
			name: "SEARCHMANAGE",
		}],
	},
	{
		title: "客服管理",
		icon: "customer-service",
		name: "CUSMODULE",
		children: [{
				title: "代工咨询",
				router: "oemConsult",
				name: "OEMCONSULT",
				children: [],
			},
			{
				title: "意见反馈",
				router: "feedback",
				name: "FEEDBACK",
			},
			{
				title: "留言频道管理",
				router: "msgChannelMng",
				name: "MSGCHANNELMNG",
				children: [],
			},
			{
				title: "客服话术管理 ",
				router: "servicescriptMng",
				name: "SERVICESCRIPTMNG",
				children: [],
			},
			{
				title: "热线/二维码管理",
				router: "hotlineQrCode",
				name: "HOTLINEQRCODE",
				children: [],
			},
			{
				title: "系统消息 ",
				router: "sysMsg",
				name: "SYSMSG",
				children: [],
			},
		],
	},

	{
		title: "系统管理",
		icon: "setting",
		name: "SYSTEMMODULE",
		children: [{
				title: "员工管理",
				router: "userList",
				name: "USERLIST",
				children: [],
			},
			{
				title: "员工角色",
				router: "roleList",
				name: "ROLELIST",
				children: [],
			},
			{
				title: "操作日志",
				router: "operationLog",
				name: "OPERATIONLOG",
				children: [],
			}
		],
	}

];